/* ============================================
   EMAIL SNIPPETS — THE HOUSE SET
   Asset: email-tpl-snippets.js
   CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-19)

   The "#" picker in the composer body, and the ⚡ button beside 📝. Loads after
   email-tpl-core.js and email-tpl-blocks.js.

   Ryan: *"I want to add some email snippets - like 1-2 sentences that can be inserted
   wherever in an email. Sort of like how HubSpot has these."*

   A SNIPPET IS NOT A SMALL TEMPLATE. A template owns the body; a snippet lands at the
   caret, mid-email, as many times as the rep wants, and knows nothing about what surrounds
   it. So there is no gate, no send ledger, no once-only rule. See the registry note in
   email-tpl-core.js for the full contract.

   TWO SHAPES, and prefer the first:
     { text: 'One sentence, with {{first_name}} if it needs one.' }
     { build: function (ctx) { return {paragraphs, warnings} } }   ← when it must READ something

   ⛔ NO EM DASHES. Every string in this file is customer-facing.
   ============================================ */
(function () {
  'use strict';

  var T = window.RQDTpl;
  var B = window.RQDTplBlocks;
  if (!T || !B) { console.error('[email-tpl] email-tpl-snippets.js loaded before the kernel'); return; }

  /* ============================================
     💳 PAYMENT LINK (Ryan 2026-10-27, replaces the ordering-instructions sentence in this snippet)
     ============================================
     The sentence and the link read live in email-tpl-blocks.js (payLinkFor / paymentSentence), shared with the 1st and
     2nd+ Quote emails so the three never drift. This snippet uses the plain "To finalize your order" opening.
     With SEVERAL quotes attached the sentence carries one link per quote, "Quote A or Quote B" (Ryan 2026-11-04).
     ⚠️ The id stays `ordering-instructions` (the catalog arrangement and every saved order key on it); only the label moves. */
  function _buildPaymentLink(ctx) {
    return B.payLinkFor(ctx).then(function (p) {
      var s = B.paymentSentence(p);
      return { paragraphs: [s.runs], warnings: s.warnings };
    });
  }
  /* 🔗 The link alone, on the clipboard (Ryan 2026-10-27: "so the rep can paste it plainly in an email or embed it in
     another word(s)"). Inserts nothing: the modal sees `copyText` and copies it (dashboard-email-modal.js _applySnippet). */
  function _buildCopyPaymentLink(ctx) {
    /* `single`: a clipboard holds one link, so with several quotes attached this still copies the deal's own and warns
       (Ryan 2026-11-04 left this snippet as it was while the sentence above grew one link per quote). */
    return B.payLinkFor(ctx, { single: true }).then(function (p) {
      return {
        paragraphs: [], warnings: p.warnings, copyText: p.link,
        notice: 'Payment link for ' + p.ref + ' copied. Paste it anywhere, or select some words and add it as a link.',
      };
    });
  }

  /* ⚠️ REGISTRATION ORDER IS LIST ORDER (see `RQDSnippets.list` / `search` with an empty query),
     so this one is FIRST deliberately. Ryan 2026-09-02: *"please put 'Ordering instructions + card
     link' at the top of the list, as it's the most common snippet we use."* Renamed "Payment link" 2026-10-27. */
  T.registerSnippet({
    id: 'ordering-instructions',
    icon: '💳',
    label: 'Payment link',
    keywords: 'payment link pay sign proposal finalize order down payment downpayment deposit card ach wire check zelle ordering instructions',
    build: _buildPaymentLink,
  });
  T.registerSnippet({
    id: 'copy-payment-link',
    icon: '🔗',
    label: 'Copy payment link',
    keywords: 'copy payment link clipboard url sign pay paste',
    build: _buildCopyPaymentLink,
  });

  /* ============================================
     ECORE INSTALLATION INSTRUCTIONS (Ryan 2026-09-13)
     ============================================
     "To see the installation instructions for the ECORE Performance dBTile, click here." The link
     lands the customer on /pages/ecore-resources with that manual's exact title pre-filled in the
     search, so they see the one document AND can browse the other 61.

     ⛔ A LINK, NEVER AN ATTACHED PDF, and that is Ryan's reasoning rather than a technical
     constraint: *"I want people to land on the actual ECORE file page, so they can browse around
     it more if they want to learn more, as opposed to only being limited to a PDF attachment."*
     (The W-9 snippet next door is the opposite call for the opposite reason.)

     ⛔ THE PRODUCT NAME COMES FROM THE MANUAL'S `covers` LIST, NEVER FROM `T.displayName`. A
     quote line reads "ECORE Performance dBTile Rubber Tile - 2.5\" Acoustic Flooring" and
     displayName only cuts at the first spaced hyphen, so it yields "ECORE Performance dBTile
     Rubber Tile". Ryan's sentence wants "Performance dBTile", and the covers entry is the only
     place that short name is written down.

     ⚠️ TWO WORDINGS, ONE SENTENCE. With a quoted product the name is the covers entry as typed
     ("the Performance dBTile"); with no quote it is the manual's own name with the brand in front
     ("the ECORE Performance dBTile"). Ryan specified both shapes. */
  function _ecoreOptionRows(ctx) {
    return Promise.all([
      T.loadEcoreDocs(),
      T.loadDetails(String((ctx && ctx.ref) || '').trim()),
    ]).then(function (res) {
      var idx = res[0];
      if (!idx) return { error: 'the ECORE document list could not be read from the resources page.' };
      var manuals = idx.manuals || [];
      if (!manuals.length) return { rows: [], manuals: manuals };

      var details = res[1] || null;
      var lines = (details && details.quote && details.quote.lineItems) || [];
      var matched = T.ecoreManualsForQuote(lines, manuals);

      var rows = [];
      var seenDoc = {};
      matched.forEach(function (m) {
        /* ⚠️ ONE ROW PER (MANUAL, PRODUCT) PAIR, not per manual: Rally and Beast are both governed
           by Performance Rolls, and the rep genuinely has to choose which product the sentence
           names. Both rows link to the same document. */
        rows.push({
          key: m.doc.id + '|' + m.name, group: 'ON THIS QUOTE',
          title: m.doc.title, url: T.ecoreManualUrl(m.doc.title),
          name: m.name, fromQuote: true, note: m.doc.title,
        });
        seenDoc[m.doc.id] = 1;
      });
      manuals.forEach(function (doc) {
        /* A manual already offered under the quoted product is NOT repeated below — two rows for
           one document with near-identical labels reads as a bug. */
        if (seenDoc[doc.id]) return;
        rows.push({
          key: doc.id, group: 'ALL TECH MANUALS',
          title: doc.title, url: T.ecoreManualUrl(doc.title),
          name: T.ecoreBrandedName(doc), fromQuote: false,
          note: T.ecoreCoversList(doc).join(', '),
        });
      });
      return { rows: rows, manuals: manuals, matchedCount: matched.length };
    });
  }

  T.registerSnippet({
    id: 'ecore-install-instructions',
    icon: '🔧',
    label: 'ECORE installation instructions',
    keywords: 'ecore install installation instructions tech manual technical document pdf resources flooring',
    /* ⛔ GREYS ONLY ON A **KNOWN**-EMPTY INDEX. `available` cannot fetch (the contract says so), and
       a row greyed because a read has not finished yet reads as "this deal cannot do this" and is
       wrong the moment the cache lands. Unknown stays available; `options` is the authority. */
    available: function () {
      var idx = T.ecoreDocs();
      if (idx && !(idx.manuals || []).length) {
        return 'The resources page has no tech manuals on it right now.';
      }
      return '';
    },
    options: _ecoreOptionRows,
    build: function (ctx) {
      var opt = ctx && ctx.option;
      if (!opt || !opt.url || !opt.name) {
        throw new Error('pick which tech manual to link to, or reopen the list if it did not load.');
      }
      /* Three runs, punctuation OUTSIDE the linked one — the same discipline the bold address
         rule imposes, and for the same reason: a linked full stop is the tell of a template that
         linked a whole string. */
      return {
        paragraphs: [[
          { t: 'To see the installation instructions for the ' + opt.name + ', ' },
          { t: 'click here', link: opt.url },
          { t: '.' },
        ]],
        warnings: [],
      };
    },
  });

  /* ============================================
     OUR W-9 (Ryan 2026-09-13)
     ============================================
     AP departments ask for it constantly. Inserting the sentence ALSO attaches the current W-9 —
     `attachHouseDocs` on the build's return, which is the `attachFromMessage` rule with a slug
     instead of a messageId: a snippet NAMES what it wants and the modal fetches it.

     ⛔ ATTACHED, NEVER LINKED, and that is the opposite call from the ECORE snippet above for the
     opposite reason. A tax document should not acquire a permanent public URL, and AP wants the
     file rather than a page. (The ECORE manual is a link precisely so the customer can browse on.)

     ⛔ THE COPY SAYS "CURRENT", NOT "2026". A W-9 is replaced every January and the sentence has to
     survive that swap for the same reason the slug does.

     ⚠️ `available` FAILS OPEN. It cannot fetch (the contract says so), so a shelf that has not
     loaded yet leaves the row live and lets `build` be the authority; greying on UNKNOWN reads as
     "this deal cannot do this" and is wrong the moment the read lands. */
  function _houseDoc(role) {
    return (window.RQD && typeof window.RQD.houseDocForRole === 'function')
      ? window.RQD.houseDocForRole(role) : null;
  }
  function _houseShelfState() {
    return (window.RQD && typeof window.RQD.houseShelf === 'function')
      ? window.RQD.houseShelf() : { state: 'unknown', items: [] };
  }

  /* CUSTOM_HOUSEDOCS_BY_CLAUDE (Ryan 2026-09-16, AIOPS 0a47981f866f) — ⛔ ONE BUILDER, EVERY HOUSE
     DOCUMENT. The W-9 snippet below was written first and every rule in it was learned the hard
     way: load the shelf before refusing, fail OPEN on an unread shelf, count "also" against the
     OTHER attachments, and never refuse a rep who attached the file by hand. The ACH and wiring
     instructions need all four, identically. A second copy would be a second thing to fix, and the
     one time it was not fixed twice the two snippets would quietly disagree about the same rule.
     So the differences — which role, which words, which refusal — are DATA, and the rules are
     written once. */
  function _registerHouseDocSnippet(spec) {
    T.registerSnippet({
      id: spec.id,
      icon: spec.icon,
      /* The parenthetical is deliberate: a snippet's label is its whole description, and the one
         thing a rep must know before clicking is that this one also puts a file on the email. */
      label: spec.label,
      keywords: spec.keywords,
      available: function (ctx) {
        var shelf = _houseShelfState();
        if (shelf.state === 'ok' && !_houseDoc(spec.role)) return spec.missing;
        var doc = _houseDoc(spec.role);
        if (doc && window.RQD && typeof window.RQD.houseDocAttached === 'function'
            && window.RQD.houseDocAttached((ctx && ctx.attachments) || [], doc)) {
          return spec.alreadyAttached;
        }
        return '';
      },
      /* ⛔ BUILD LOADS THE SHELF; IT DOES NOT PEEK AT IT (Ryan 2026-09-13, first live use).
         The shelf is read when the ATTACH MENU opens, so a rep who inserts this snippet without
         ever touching the paperclip met an empty cache and a red "no W-9 is on the shelf yet" —
         about a document that was sitting there. `available()` peeks because it must (it is
         synchronous and cannot fetch, and it deliberately fails OPEN); `build` is async and has no
         such excuse. The refusal now only fires against a shelf we have actually read. */
      build: function (ctx) {
        var load = (window.RQD && typeof window.RQD.loadHouseDocs === 'function')
          ? window.RQD.loadHouseDocs()
          : Promise.resolve(_houseShelfState());
        return Promise.resolve(load).then(function () { return _houseDocBuild(spec, ctx); });
      },
    });
  }

  _registerHouseDocSnippet({
    role: 'w9',
    id: 'house-doc-w9',
    icon: '🧾',
    label: 'Our W-9 (attached)',
    keywords: 'w9 w-9 tax id ein taxpayer identification vendor setup form paperwork attach',
    /* ⛔ THE COPY SAYS "CURRENT", NOT "2026" — see the note above the role ladder. */
    sentence: 'I have attached our current W-9 to this email.',
    alsoSentence: 'I have also attached our W-9 to this email.',
    missing: 'No W-9 is on the house documents shelf. An admin adds one in Settings → Admin: House Documents.',
    alreadyAttached: 'The W-9 is already attached to this email.',
    unreadable: 'the house documents shelf could not be read, so the W-9 could not be attached. Try the attach menu under Frequently required.',
    absent: 'no W-9 is on the house documents shelf yet. An admin adds one in Settings → Admin: House Documents.',
  });

  /* ============================================
     OUR ACH AND WIRING INSTRUCTIONS (Ryan 2026-09-16, AIOPS 0a47981f866f)
     ============================================
     Ryan's call on both open questions: the sentence mirrors the W-9's word for word, and every
     rep may insert it — the same rule the W-9 has, because a rep who may email a customer could
     already send them the same PDF off their own desktop.

     ⛔ THE BANK DETAILS STAY IN THE PDF. The sentence names the attachment and says nothing about
     an account, so nothing here can be quoted back as an instruction to pay somewhere, and there
     is exactly one copy of the numbers to correct the day they change.

     ⚠️ THE SHELF IS EMPTY UNTIL RYAN UPLOADS IT. There is no ACH document on the shelf today
     (checked: it holds the W-9 and three tax-exemption certificates), so until the PDF goes up
     under the slug `ach-wiring` this snippet refuses, by name, with the slug in the message. That
     is the same thing the W-9 snippet did before its document arrived. */
  _registerHouseDocSnippet({
    role: 'ach',
    id: 'house-doc-ach',
    icon: '🏦',
    label: 'Our ACH and wiring instructions (attached)',
    keywords: 'ach wire wiring bank routing account number transfer eft remittance pay payment instructions deposit attach',
    sentence: 'I have attached our current ACH and wiring instructions to this email.',
    alsoSentence: 'I have also attached our ACH and wiring instructions to this email.',
    missing: 'No ACH and wiring instructions are on the house documents shelf. An admin adds the PDF in Settings → Admin: House Documents under the slug ach-wiring.',
    alreadyAttached: 'The ACH and wiring instructions are already attached to this email.',
    unreadable: 'the house documents shelf could not be read, so the ACH and wiring instructions could not be attached. Try the attach menu under Frequently required.',
    absent: 'no ACH and wiring instructions are on the house documents shelf yet. An admin adds the PDF in Settings → Admin: House Documents under the slug ach-wiring.',
  });

  function _houseDocBuild(spec, ctx) {
      var shelf = _houseShelfState();
      var doc = _houseDoc(spec.role);
      if (!doc) {
        if (shelf.state === 'error') {
          throw new Error(spec.unreadable);
        }
        throw new Error(spec.absent);
      }
      /* ⛔ ALREADY ATTACHED IS NOT A REFUSAL. A rep who attached it by hand and now wants the
         sentence is doing the right thing; refusing there is the same lie as "attach the quote
         first". The sentence goes in and the slug is simply omitted. */
      var atts = (ctx && ctx.attachments) || [];
      var already = window.RQD && typeof window.RQD.houseDocAttached === 'function'
        && window.RQD.houseDocAttached(atts, doc);

      /* ⛔ "ALSO" IS COUNTED AGAINST THE OTHER ATTACHMENTS, NOT ALL OF THEM (Ryan 2026-09-13).
         The rule is "if the email already has an attachment on it when this snippet is pressed",
         and THIS document does not count: a rep who attached the W-9 by hand and then wants the
         sentence has ONE attachment, and "I have ALSO attached our W-9" would be promising a
         second document that is not there. So the test is whether anything OTHER than this
         document is on the email.
         ⚠️ A locked or display-only pill counts — it is attached, whoever put it there. */
      var others = atts.filter(function (a) {
        if (!a) return false;
        return !(window.RQD && typeof window.RQD.houseDocAttached === 'function'
          && window.RQD.houseDocAttached([a], doc));
      }).length;

      var out = {
        paragraphs: [[
          { t: others ? spec.alsoSentence : spec.sentence },
        ]],
        warnings: [],
      };
      if (!already) out.attachHouseDocs = [doc.slug];
      return out;
  }

  /* ============================================
     THE CUSTOMER'S DESIGN, AND THE VERSIONS WE MADE FROM IT (Ryan 2026-09-01)
     ============================================
     Three snippets over one lookup. A buyer designs weights on the site; the submission lands on
     the deal as an immutable share. A rep adopts it as `-A` of a chain and saves improvements as
     `-B`, `-C`. These put the links in an email.

     ⛔ THEY REFUSE RATHER THAN GUESS, the same way `ordering-instructions` refuses with no quote
     attached. Every fact in these sentences is a property of a real record — the product noun, the
     link, how many versions exist — so with nothing linked there is nothing true to say, and a
     plausible sentence with a dead link is the one outcome worth failing to avoid.

     ⚠️ THE NOUN COMES FROM THE DESIGN, NOT FROM THE DEAL. `product` on the linked design is the
     designer's own `category|kind` ("dumbbell|Round Rubber"), so the sentence says "dumbbells"
     when it knows and "weights" when the deal holds more than one kind. Never a category we
     invented to fill the gap.

     ⛔ NO EM DASHES. Every string here is customer-facing. */

  /** The public, customer-facing link to a share id. Never the portal URL: it would ask a
      committee member to log in. */
  function _wdLink(shareId) {
    return 'https://www.blueskyfitsupply.com/pages/weight-designer?d=' + encodeURIComponent(shareId);
  }

  /* "dumbbells" / "grip plates" / "weights". Plural, because an order is always more than one. */
  var _WD_NOUNS = {
    dumbbell: 'dumbbells',
    barbell: 'barbells',
    plate: 'plates',
    bumper: 'bumper plates',
    grip: 'grip plates',
  };

  function _wdNoun(designs) {
    var seen = {};
    (designs || []).forEach(function (d) {
      var cat = String((d && d.product) || '').split('|')[0].trim().toLowerCase();
      if (cat) seen[cat] = true;
    });
    var cats = Object.keys(seen);
    /* ⚠️ "weights" IS THE HONEST ANSWER FOR A MIXED ORDER, not a fallback we settled for. A buyer
       who designed dumbbells AND bumper plates did not design a "dumbbell", and naming one of the
       two would be worse than naming the family. */
    if (cats.length !== 1) return 'weights';
    return _WD_NOUNS[cats[0]] || 'weights';
  }

  /** The weight designs on this deal, split into the customer's and ours. */
  function _wdDesigns(ctx) {
    var deal = T.dealByRef((ctx && ctx.ref) || '') || {};
    var files = (deal.linkedFiles || []).filter(function (f) {
      return f && f.type === 'weights' && f.designId && !f.missing;
    });
    var theirs = files.filter(function (f) { return f.authored === 'customer' || f.store === 'wd-share'; });
    /* The chain link is recorded on whichever version was open when the rep copied it; any file on
       the deal carrying one is the same link. */
    var chain = '';
    files.some(function (f) { if (f.chainShareId) { chain = f.chainShareId; return true; } return false; });
    /* CUSTOM_WEIGHTDESIGNER_BY_CLAUDE (Ryan 2026-09-02) — OUR VERSION'S OWN LINK, which is a
       different link from the chain's. Snippet 2 says "the design we made for you" and used the
       chain link, so it opened on the CUSTOMER'S design and paged through everything - Ryan:
       *"opens up both their and ours and is still scrollable."* The sentence promises ours.
       WARNING: THE NEWEST OF OURS, by revision letter descending. With `-B` and `-C` on the deal,
       "the design we made for you" is the latest one we made, not the first. */
    var ours = files.filter(function (f) { return theirs.indexOf(f) === -1; });
    var ourShare = '';
    ours.slice()
      .sort(function (x, y) { return String(y.designRef || '').localeCompare(String(x.designRef || '')); })
      .some(function (f) { if (f.soloShareId) { ourShare = f.soloShareId; return true; } return false; });
    return { all: files, theirs: theirs, ours: ours, chainShareId: chain, ourShareId: ourShare };
  }

  /* CUSTOM_INQUIRYFOLLOWUP_BY_CLAUDE (Ryan 2026-09-26) — the inquiry follow-up links both designs in
     its own words, so it reads the SAME lookup and the same public link rather than a second copy.
     Published on the kernel's toolkit; the inquiry file only calls these at build time, long after
     this file has loaded. */
  T.wdDesigns = _wdDesigns;
  T.wdLink = _wdLink;

  /* ── 1. their design alone ───────────────────────────────────────────────────────────────── */

  T.registerSnippet({
    id: 'wd-customer-design',
    available: function (ctx) {
      return _wdDesigns(ctx).theirs.length ? '' : 'This deal has no design the customer made.';
    },
    icon: '🏋️',
    label: 'Link to the design they made',
    keywords: 'weight designer design link customer original submitted dumbbell plate barbell',
    build: function (ctx) {
      var d = _wdDesigns(ctx);
      if (!d.theirs.length) {
        throw new Error('this deal has no weight design from the customer, so there is no link to send');
      }
      var noun = _wdNoun(d.theirs);
      return {
        paragraphs: [[
          { t: 'As a reminder, ' },
          { t: 'here is a link', link: _wdLink(d.theirs[0].designId) },
          { t: ' to the ' + noun + ' you designed on our website.' },
        ]],
        warnings: [],
      };
    },
  });

  /* ── 2. ours, made from theirs ───────────────────────────────────────────────────────────── */

  T.registerSnippet({
    id: 'wd-our-version',
    available: function (ctx) {
      /* ⛔ GREY BEFORE THE CLICK, not a refusal after it. `build` still throws — it is the
         authority and it runs against a fresh read — but a row the rep cannot use should not
         look usable. Ryan: *"should be grayed out, if we didn't actually make them a new
         version."* The reason rides as a tooltip, never as sub-text. */
      var d = _wdDesigns(ctx);
      if (!d.all.length) return 'This deal has no weight design.';
      /* ⛔ GATED ON OUR OWN LINK, NOT THE CHAIN'S. A deal can have a chain link and still have
         nothing of ours worth sending on its own, and this row's sentence is about ours. */
      if (!d.ourShareId) {
        return 'No version of ours yet. Open the design, make your changes, and use "Save as new version". The link makes itself.';
      }
      return '';
    },
    icon: '✨',
    label: 'Link to the version we made for them',
    keywords: 'weight designer version modified our design improved link',
    build: function (ctx) {
      var d = _wdDesigns(ctx);
      if (!d.ourShareId) {
        /* ⛔ NAMES THE RECOVERY, because this one is entirely fixable and the rep is two clicks
           from fixing it. The link exists only once somebody has made it. */
        throw new Error('no version of ours yet. Open the design, make your changes, and use "Save as new version". The link makes itself.');
      }
      /* ⚠️ THE NOUN COMES FROM OUR VERSIONS, not from every design on the deal, because this
         sentence is about ours. It is the same product in practice; reading it off the designs the
         link actually carries is what keeps that true if it ever stops being. */
      var noun = _wdNoun(d.ours.length ? d.ours : d.all);
      return {
        paragraphs: [[
          { t: 'Here is a link to the ' + noun + ' design we made for you', link: _wdLink(d.ourShareId) },
          { t: ', where we took your original design and made some modifications to it which we '
            + 'think enhanced the overall appearance.' },
        ]],
        warnings: [],
      };
    },
  });

  /* ── 3. both, in one link ────────────────────────────────────────────────────────────────── */

  T.registerSnippet({
    id: 'wd-both-designs',
    available: function (ctx) {
      /* ⛔ GREY BEFORE THE CLICK, not a refusal after it. `build` still throws — it is the
         authority and it runs against a fresh read — but a row the rep cannot use should not
         look usable. Ryan: *"should be grayed out, if we didn't actually make them a new
         version."* The reason rides as a tooltip, never as sub-text. */
      var d = _wdDesigns(ctx);
      if (!d.all.length) return 'This deal has no weight design.';
      if (!d.chainShareId) {
        return 'No version link yet: open the design, save your version, then use '
          + '"Copy link to all versions" in the Save menu.';
      }
      return '';
    },
    icon: '🔀',
    label: 'Link to their design plus ours',
    keywords: 'weight designer both original versions compare arrows link',
    build: function (ctx) {
      var d = _wdDesigns(ctx);
      if (!d.chainShareId) {
        throw new Error('no version link yet: open the design, save your version, then use '
          + '"Copy link to all versions" in the Save menu');
      }
      var noun = _wdNoun(d.all);
      /* How many are OURS. The chain is the customer's `-A` plus everything after it, so the count
         the sentence needs is one less than the number of designs on the deal.
         ⚠️ FLOORED AT ONE. The link is only offered once a version exists, and a sentence reading
         "you can see the 0 versions we made" is the shape this guard exists to prevent. */
      var ours = Math.max(1, d.all.length - (d.theirs.length || 1));
      var tail = ours === 1
        ? ', and if you use the arrow button you can see a second version we made which we think you will like even more.'
        : (ours === 2
          ? ', and if you use the arrow buttons you can see a couple more versions we made for you as well.'
          : ', and if you use the arrow buttons you can see the ' + ours + ' other versions we put '
            + 'together, so you can get a feel for what we can do.');
      return {
        paragraphs: [[
          { t: 'Here is a link', link: _wdLink(d.chainShareId) },
          { t: ' where you can see the original ' + noun + ' design you submitted' + tail },
        ]],
        warnings: [],
      };
    },
  });
  /* ============================================
     🚚 FREIGHT DETAILS FOR THEIR OWN CARRIER (LOGAN 5ea246b1adfb, Ryan 2026-10-31)
     ============================================
     RW-1560-A: the customer said $843 freight looked high next to the $450-550 he found. One click puts the intro and the
     shipment a carrier quotes on (pickup and delivery city and ZIP, the pallets, NMFC and class, the add-ons, the
     supplier's pallet fee) into the email, so he can price it with his own shipping company. Zero agent tokens: it is
     one read of GET /shipment-spec, built by the worker from the rate runs the deal already keeps.

     ⛔ NEVER OUR COST, THE CARRIER, THE BROKER OR A QUOTE ID. The worker never sends them, and nothing here prints the
     vendor name the read carries for LOGAN. Ryan, on the preview: no commodity line ("they know it's equipment"), the
     distance in the opening paragraph, and the pallet fee for a vendor that has one.

     ⚠️ WHICH QUOTE (the card): the quote attached to this email; with two or more attached, the rep picks one or all of
     them and each gets its own block; with none attached, the revision the customer was sent most recently.

     ⛔ GREYED, NEVER HALF-FILLED (Ryan 2026-10-31: "Grey it out"). A deal nobody rated through the rate tool has no
     pallet lines to send, and an email with a pickup and no pallets is worse than none. `prepare` reads the answer
     before the menu paints, so the row is grey on the first open, not the second.

     ⚠️ THE INTRO IS EDITABLE on Abby Emails -> Templates & snippets (Ryan's answer on the card). Every variant must keep
     its {TOKENS}; the editor refuses a save that drops one.
     ⛔ NO EM DASHES. Customer-facing. */
  var FD = T.definePhrases('freight-details', {
    'intro.one': 'We shopped around dozens of carriers across a few different freight brokers, and the rate we quoted '
      + 'you was the best we could get. With high fuel prices and a driver shortage, freight costs more than we\'d like '
      + 'right now, but I can guarantee our rate is competitive. If you have a shipping company you\'d like to use, here '
      + 'are the details for this shipment, which travels about {MILES} miles from pickup to delivery:',
    'intro.one-nomiles': 'We shopped around dozens of carriers across a few different freight brokers, and the rate we '
      + 'quoted you was the best we could get. With high fuel prices and a driver shortage, freight costs more than we\'d '
      + 'like right now, but I can guarantee our rate is competitive. If you have a shipping company you\'d like to use, '
      + 'here are the details for this shipment:',
    'intro.many': 'We shopped around dozens of carriers across a few different freight brokers, and the rate we quoted '
      + 'you was the best we could get. With high fuel prices and a driver shortage, freight costs more than we\'d like '
      + 'right now, but I can guarantee our rate is competitive. If you have a shipping company you\'d like to use, here '
      + 'are the details for these {COUNT} shipments, which travel {DISTANCES}:',
    'intro.many-nomiles': 'We shopped around dozens of carriers across a few different freight brokers, and the rate we '
      + 'quoted you was the best we could get. With high fuel prices and a driver shortage, freight costs more than we\'d '
      + 'like right now, but I can guarantee our rate is competitive. If you have a shipping company you\'d like to use, '
      + 'here are the details for these {COUNT} shipments:',
  }, {
    MILES: 'the road-distance estimate between the two ZIPs, rounded to the nearest 50, with its comma: "2,450"',
    COUNT: 'how many shipments follow, as a number: "2"',
    DISTANCES: 'each pickup\'s distance: "about 2,450 miles from Knoxville, TN and about 2,800 miles from Lancaster, PA"',
  });

  var _fdCache = {};   // query string -> { quotes } | { error }

  /* The quote refs riding on THIS email, deduped, in attachment order. */
  function _fdAttachedRefs(ctx) {
    var seen = {}, out = [];
    ((ctx && ctx.attachments) || []).forEach(function (a) {
      var r = a && a.quoteMeta && a.quoteMeta.ref ? String(a.quoteMeta.ref).toUpperCase() : '';
      if (r && !seen[r]) { seen[r] = 1; out.push(r); }
    });
    return out;
  }

  /* The read this email needs. With no quote attached: every revision of the deal, and the worker picks the one the
     customer was sent last. */
  function _fdQuery(ctx, option) {
    var refs = option && option.refs ? option.refs : _fdAttachedRefs(ctx);
    if (refs.length) return '/shipment-spec?refs=' + encodeURIComponent(refs.join(','));
    var ref = String((ctx && ctx.ref) || '').trim().toUpperCase();
    if (!ref) return '';
    var chain = (T.chainDeals(ref) || []).map(function (d) { return String(d.reference || '').toUpperCase(); }).filter(Boolean);
    if (chain.indexOf(ref) === -1) chain.unshift(ref);
    return '/shipment-spec?refs=' + encodeURIComponent(chain.slice(0, 10).join(',')) + '&pick=latest-sent';
  }

  function _fdLoad(q) {
    if (!q) return Promise.resolve({ quotes: [] });
    if (_fdCache[q] && _fdCache[q].then) return _fdCache[q];
    if (_fdCache[q]) return Promise.resolve(_fdCache[q]);
    var api = T.api();
    if (!api) return Promise.resolve({ error: 'the portal is still loading. Try again in a moment.' });
    var p = api.get(q).then(function (d) {
      var v = { quotes: (d && d.quotes) || [] };
      _fdCache[q] = v;
      return v;
    }).catch(function (e) {
      delete _fdCache[q];    // a failed read is not "no shipment"; the next try reads again
      return { error: 'the shipment details could not be read (' + ((e && e.message) || 'network') + '). Try again.' };
    });
    _fdCache[q] = p;
    return p;
  }

  var _fdNoShip = 'No freight rate has been run on this deal through the rate tool yet, so there are no shipment details to send.';

  function _fdCommas(n) { return String(Math.round(Number(n) || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function _fdLb(n) { var v = Math.round((Number(n) || 0) * 10) / 10; return _fdCommas(Math.floor(v)) + (v % 1 ? String(v % 1).slice(1, 3) : '') + ' lb'; }
  function _fdMoney(n) { var v = Number(n) || 0; return '$' + (v % 1 ? v.toFixed(2) : _fdCommas(v)); }
  function _fdPlace(p) {
    if (!p) return '';
    var head = [p.city, p.state].filter(Boolean).join(', ');
    return (head + (p.zip ? ' ' + p.zip : '')).trim();
  }
  function _fdCityState(p) { return p ? [p.city, p.state].filter(Boolean).join(', ') || (p.zip || '') : ''; }
  function _fdUnitWord(pack, n) {
    var w = String(pack || 'Pallets').trim().toLowerCase();
    if (!w || w === 'pallets' || w === 'pallet' || w === 'skids' || w === 'skid') w = 'pallets';
    var sing = w.replace(/s$/, '');
    return n === 1 ? sing : (sing + 's');
  }
  function _fdClass(it) {
    if (it.nmfc && it.class) return 'NMFC ' + it.nmfc + ', class ' + it.class;
    if (it.class) return 'Class ' + it.class;
    return it.nmfc ? 'NMFC ' + it.nmfc : '';
  }

  function _fdBullets(s) {
    var B = function (t) { return { list: 'bullet', runs: [{ t: t }] }; };
    var out = [];
    out.push(B('Pickup: ' + _fdPlace(s.pickup)));
    out.push(B('Delivery: ' + _fdPlace(s.delivery) + (s.residential ? ' (residential)' : ' (commercial)')));
    var items = s.items || [];
    var classes = {};
    items.forEach(function (it) { classes[_fdClass(it)] = 1; });
    var oneClass = Object.keys(classes).length === 1;
    items.forEach(function (it) {
      var n = it.pieces || 1;
      var dims = (it.length && it.width && it.height) ? it.length + ' x ' + it.width + ' x ' + it.height + ' in, ' : '';
      var wt = n > 1 ? _fdLb(it.weight / n) + ' each' : _fdLb(it.weight);
      var cls = oneClass ? '' : (_fdClass(it) ? ', ' + _fdClass(it).replace(/^Class/, 'class') : '');
      out.push(B(n + ' ' + _fdUnitWord(it.packaging, n) + ': ' + dims + wt + cls));
    });
    if ((s.handlingUnits || 0) > 1) out.push(B('Total weight: ' + _fdLb(s.totalWeight)));
    if (oneClass && Object.keys(classes)[0]) out.push(B(Object.keys(classes)[0]));
    var a = s.addOns || {}, adds = [];
    if (a.liftGate) adds.push('liftgate');
    if (a.deliveryAppointment) adds.push('delivery appointment');
    if (a.callAhead) adds.push('call-ahead');
    if (a.residential) adds.push('residential delivery');
    if (a.insideDelivery) adds.push('inside delivery');
    if (a.limitedAccess) adds.push('limited access delivery');
    /* ⛔ "insurance" ALONE (Ryan 2026-10-31): the declared value is what the goods cost us, never customer copy. */
    if (a.insurance) adds.push('insurance');
    out.push(B('Add-ons: ' + (adds.length ? adds.join(', ') : 'none')));
    var f = s.palletFee;
    if (f && f.amount > 0) {
      /* ⛔ WHO CHARGES WHOM IS NOT THE CUSTOMER'S BUSINESS (Ryan 2026-10-31: "Keep it simple"). */
      out.push(B(f.label + ': ' + _fdMoney(f.amount) + ' flat rate included in freight'));
    }
    return out;
  }

  /* Exposed for the plain-node harness (tests/freight-details-snippet.test.mjs). */
  T.freightDetailsParagraphs = function (quotes) {
    var withShip = (quotes || []).filter(function (q) { return q && q.shipments && q.shipments.length; });
    var all = [];
    withShip.forEach(function (q) { q.shipments.forEach(function (s) { all.push(s); }); });
    if (!all.length) return null;
    var paras = [];
    if (all.length === 1) {
      var m = all[0].miles;
      paras.push(m ? FD['intro.one']({ MILES: _fdCommas(m) }) : FD['intro.one-nomiles']({}));
    } else {
      var seen = {}, legs = [];
      all.forEach(function (s) {
        if (!s.miles) return;
        var k = _fdCityState(s.pickup) + '|' + s.miles;
        if (seen[k]) return;
        seen[k] = 1;
        legs.push('about ' + _fdCommas(s.miles) + ' miles from ' + _fdCityState(s.pickup));
      });
      var dist = legs.length <= 2 ? legs.join(' and ') : legs.slice(0, -1).join(', ') + ' and ' + legs[legs.length - 1];
      paras.push(legs.length === all.filter(function (s) { return s.miles; }).length && legs.length
        ? FD['intro.many']({ COUNT: String(all.length), DISTANCES: dist })
        : FD['intro.many-nomiles']({ COUNT: String(all.length) }));
    }
    var n = 0;
    withShip.forEach(function (q) {
      if (withShip.length > 1) paras.push([{ t: 'For quote ' + q.ref + ':', b: true }]);
      q.shipments.forEach(function (s) {
        n += 1;
        if (all.length > 1) paras.push([{ t: 'Shipment ' + n + ': from ' + _fdCityState(s.pickup), b: true }]);
        _fdBullets(s).forEach(function (b) { paras.push(b); });
      });
    });
    return paras;
  };

  T.registerSnippet({
    id: 'freight-details',
    icon: '🚚',
    label: 'Freight details',
    keywords: 'freight shipping details carrier specs pallet dims weight class nmfc pickup delivery liftgate shipment too high expensive own carrier broker',
    /* Read before the menu paints (RQDSnippets.listFor awaits it, briefly), so a deal with nothing to send is grey on
       the first open. With two or more quotes attached there is a picker, and each pick reads its own refs. */
    prepare: function (ctx) {
      if (_fdAttachedRefs(ctx).length > 1) return Promise.resolve();
      return _fdLoad(_fdQuery(ctx));
    },
    available: function (ctx) {
      if (_fdAttachedRefs(ctx).length > 1) return '';
      var v = _fdCache[_fdQuery(ctx)];
      if (!v || v.then || v.error) return '';            // unknown fails OPEN; build is the authority
      var any = (v.quotes || []).some(function (q) { return q.shipments && q.shipments.length; });
      return any ? '' : _fdNoShip;
    },
    optionsWhen: function (ctx) { return _fdAttachedRefs(ctx).length > 1; },
    optionsPlaceholder: 'Search quotes…',
    options: function (ctx) {
      var refs = _fdAttachedRefs(ctx);
      var rows = refs.map(function (r) {
        return { key: r, group: 'ATTACHED QUOTES', title: r, note: 'This quote only', refs: [r] };
      });
      rows.unshift({ key: '*', group: 'ATTACHED QUOTES', title: 'All ' + refs.length + ' attached quotes', note: 'One block per quote', refs: refs });
      return { rows: rows };
    },
    build: function (ctx) {
      var q = _fdQuery(ctx, ctx && ctx.option);
      if (!q) throw new Error('open a deal first: there is no quote to read the shipment from.');
      return _fdLoad(q).then(function (v) {
        if (v.error) throw new Error(v.error);
        var paras = T.freightDetailsParagraphs(v.quotes);
        if (!paras) throw new Error(_fdNoShip.charAt(0).toLowerCase() + _fdNoShip.slice(1) + ' Run the freight rate first.');
        var warnings = [];
        (v.quotes || []).forEach(function (x) {
          (x.missing || []).forEach(function (m) {
            warnings.push('One supplier on ' + x.ref + ' has no saved shipment details, so it is not in the list.');
          });
        });
        return { paragraphs: paras, warnings: warnings };
      });
    },
  });
  /* END 🚚 FREIGHT DETAILS */
})();
